import * as z from 'zod';
import { EntityId, Tag } from './base-schemas';
import { isoDateTimeToDayJs, smallIntToBoolean } from './base-codecs';
export const CountryModel = z.object({
    _tag: Tag('CountryModel'),
    id: EntityId,
    iso_code: z.string(),
    default_language: z.string().nullable(),
    name_en: z.string(),
    name_sv: z.string(),
    name_de: z.string().nullable(),
    dialling_code: z.string(),
    is_common: smallIntToBoolean,
    name: z.string(), // appended attribute
    created_at: isoDateTimeToDayJs.nullable(),
    updated_at: isoDateTimeToDayJs.nullable()
});
